// 국가법령정보센터 언론중재법 제14조·제16조, 민법 제157조·제160조 확인: 2026-10-18.
export const LEGAL_CHECKED_ON='2026-10-18';
export const DEADLINE_LAW='https://law.go.kr/LSW/lsLinkCommonInfo.do?chrClsCd=010202&lsJoLnkSeq=1020170489';
export function parseDay(value:string): Date {
 const date=new Date(`${value}T00:00:00Z`);
 if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !Number.isFinite(date.getTime()) || date.toISOString().slice(0,10)!==value) throw new Error('DATE_INVALID');
 return date;
}
export function addMonths(value:string,months:number):string {
 const day=parseDay(value); const target=new Date(Date.UTC(day.getUTCFullYear(),day.getUTCMonth()+months,1));
 const last=new Date(Date.UTC(target.getUTCFullYear(),target.getUTCMonth()+1,0)).getUTCDate();
 target.setUTCDate(Math.min(day.getUTCDate(),last));return target.toISOString().slice(0,10);
}
export function correctionDeadline({knownOn,reportedOn}:{knownOn:string;reportedOn:string}):string {
 parseDay(knownOn);parseDay(reportedOn);
 if (knownOn<reportedOn) throw new Error('KNOWN_BEFORE_REPORT');
 return [addMonths(knownOn,3),addMonths(reportedOn,6)].sort()[0]!;
}
